import Vue from 'vue';
import VueBarcodeScanner from 'vue-barcode-scanner';

// inject vue barcode scanner
Vue.use(VueBarcodeScanner);

export default VueBarcodeScanner;
